import axios from "axios";
import {
  getBaseUrl,
  Microservice,
} from "@funded-here-interface/common/src/constant/baseUrl";
import { getApiResponseErrorMsg } from "@funded-here-interface/common/src/Utils/apiHelper";
import { LoanStatus } from "../constant/enum";
import { MRT_ColumnFiltersState } from "mantine-react-table";

interface LoanDisbursementRequest {
  token: string;
  type: LoanStatus;
  skuIds?: string;
  columnFilters: string;
  sort: string;
}

const downloadDisbursementCSV = async ({
  token,
  type,
  skuIds,
  columnFilters,
  sort,
}: LoanDisbursementRequest) => {
  const url = `${getBaseUrl(Microservice.SKU_FINANCE)}/sku-finance/loan-disbursement/download-disbursement-csv`;

  try {
    const response = await axios.post(
      url,
      {
        skuStatusFilterType: type,
        skuIds,
        columnFilters,
        sort,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    const message = getApiResponseErrorMsg(error);
    throw new Error(message);
  }
};

export default downloadDisbursementCSV;
